export const DashboardPage = 'dashboard';
export const ProfilePage = 'profile';
export const PatientsPage = 'patients';
export const PatientDetailPage = 'patients/:patientId';
export const PatientAnamnesisPage = 'patients/:patientId/anamnesis';
export const ReportPage = 'report';
export const SignInPage = 'sign-in';
export const SignUpPage = 'sign-up';
export const VerifyEmailPage = 'verify-email';
export const AuthConflictPage = 'auth-conflict';
export const WelcomePage = 'welcome';
export const SubscribePage = 'subscribe/:planId';
export const PrivacyPolicyPage = 'privacy-policy';
export const TermsOfUsePage = 'terms-of-use';
export const BillingPage = 'settings/billing';
export const SurveysPage = 'surveys';
export const SurveyPreviewPage = 'surveys/:id/preview';
export const CustomSurveyBuilderPage = 'surveys/custom/:surveyId';
export const SurveyResponsePage = 'surveys/reports/:reportId';
export const AnswerSurveyPage = 'patients/survey/answer';
export const TestPreviewPage = 'assets/:id/preview';
export const TestResponsePage = 'patients/:patientId/tests/assignments/:assignmentId/answers';
export const AnswerTestPage = 'patients/test/answer';
export const AssetsPage = 'assets';
export const ToolsPageRoute = 'tools';
export const HelpPage = 'help';
export const HelpTopicPage = 'help/:topicId';
export const HelpArticlePage = 'help/:topicId/:articleSlug';
export const ReportTemplatePreviewPage = 'reports/templates/:templateId/preview';
export const SupportPage = 'support';
export const SupportTicketPage = 'support/:ticketId';
export const SupportInboxPage = 'support/inbox';
export const FeatureFlagsAdminPage = 'admin/feature-flags';
